<template>
  <div class="row">
    <!-- Header -->
    <div class="col-12 mb-4">
      <div class="d-flex align-items-center justify-content-between flex-wrap">
        <div class="d-flex align-items-center">
          <button @click="back" class="btn btn-outline-secondary btn-icon-text py-2 px-3 mr-3">
            <i class="mdi mdi-arrow-left mr-1"></i> {{ $t('common.back') }}
          </button>
          <div>
            <h2 class="text-white font-weight-bold mb-1">
              <i class="mdi mdi-account-group text-primary mr-1"></i>
              {{ squad.name || $t('squad.detailsTitle') }}
            </h2>
            <p class="text-muted small mb-0">{{ $t('squad.detailsSubtitle') }}</p>
          </div>
        </div>
        <div class="d-flex align-items-center gap-2 mt-2 mt-md-0">
          <router-link
            :to="{ name: 'EditSquad', params: { id: id } }"
            class="btn btn-primary px-3 py-2 mr-2 font-weight-bold"
          >
            <i class="mdi mdi-lead-pencil mr-1"></i> {{ $t('common.edit') }}
          </router-link>
          <button
            type="button"
            class="btn btn-outline-danger px-3 py-2"
            @click="confirmDelete"
            :disabled="loading"
          >
            <i class="mdi mdi-delete-outline mr-1"></i> {{ $t('common.delete') }}
          </button>
        </div>
      </div>
    </div>

    <!-- Main Card -->
    <div class="col-12 grid-margin">
      <div class="card border border-secondary">
        <div class="card-body p-4">
          <div class="row">
            <div class="col-md-7 mb-4">
              <span class="badge badge-outline-info px-3 py-2 font-weight-bold text-uppercase mb-3 d-inline-block">
                <i class="mdi mdi-shield-account mr-1"></i> {{ $t('nav.squads') }}
              </span>

              <h3 class="text-white font-weight-bold mb-3">{{ squad.name }}</h3>

              <div class="p-3 bg-dark rounded border border-secondary mb-4">
                <label class="text-muted small text-uppercase font-weight-bold d-block mb-1">{{ $currentLocale === 'id' ? 'Cakupan Tim / Divisi' : 'Team / Division Scope' }}</label>
                <p class="text-white mb-0 small">
                  {{ $currentLocale === 'id' ? 'Seluruh misi atau KPI yang ditargetkan untuk divisi ini akan otomatis muncul pada dasbor anggota tim yang tergabung dalam divisi ini.' : 'All quests or KPIs targeted for this division will automatically appear on the dashboard of team members belonging to this division.' }}
                </p>
              </div>

              <div class="text-muted small" v-if="squad.created_at">
                <i class="mdi mdi-clock-outline mr-1"></i> {{ $currentLocale === 'id' ? 'Dibuat pada' : 'Created on' }} {{ formatDate(squad.created_at) }}
              </div>
            </div>

            <div class="col-md-5 mb-4">
              <div class="p-4 bg-dark rounded border border-secondary h-100 d-flex flex-column justify-content-center text-center">
                <div class="d-flex align-items-center justify-content-center mb-3">
                  <div
                    class="rounded-circle d-flex align-items-center justify-content-center"
                    style="width: 60px; height: 60px; background: rgba(59, 130, 246, 0.15); border: 1px solid rgba(59, 130, 246, 0.3);"
                  >
                    <i class="mdi mdi-account-group text-primary display-4" style="font-size: 32px;"></i>
                  </div>
                </div>
                <h5 class="text-white font-weight-bold mb-1">{{ squad.name }}</h5>
                <p class="text-muted small mb-0">{{ $currentLocale === 'id' ? 'Divisi Aktif Organisasi' : 'Active Organization Division' }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDetailSquad, deleteSquad } from "../../services/squadService";
import Swal from 'sweetalert2';
import moment from 'moment';

export default {
  name: 'DetailSquad',
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data: () => ({
    squad: {},
    loading: false,
  }),
  methods: {
    back() {
      this.$router.go(-1);
    },
    async fetchSquad() {
      try {
        const response = await getDetailSquad(this.id);
        this.squad = response.data || {};
      } catch (err) {
        console.error('Error fetching squad details:', err);
      }
    },
    confirmDelete() {
      Swal.fire({
        title: this.$t('squad.confirmDelete'),
        text: this.$t('common.confirmDelete'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#ef4444',
        cancelButtonColor: '#6b7280',
        confirmButtonText: this.$t('common.delete'),
        cancelButtonText: this.$t('common.cancel'),
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            this.loading = true;
            await deleteSquad(this.id);
            Swal.fire({
              icon: 'success',
              title: this.$t('common.success'),
              text: this.$t('squad.deletedSuccess'),
              confirmButtonColor: '#3b82f6'
            });
            this.$router.push('/squad');
          } catch (err) {
            Swal.fire({
              icon: 'error',
              title: this.$t('common.error'),
              text: err.response?.data?.message || (this.$currentLocale === 'id' ? 'Gagal menghapus divisi' : 'Failed to delete division'),
            });
          } finally {
            this.loading = false;
          }
        }
      });
    },
    formatDate(date) {
      if (!date) return '-';
      return moment(date).format('DD MMM YYYY, HH:mm');
    }
  },
  mounted() {
    this.fetchSquad();
  }
};
</script>